package com.trevorwiebe.timesheet.core.domain.model

import com.trevorwiebe.timesheet.core.domain.dto.TimeOffRequestDto
import kotlinx.datetime.LocalDate
import kotlinx.datetime.LocalDateTime

data class TimeOffRequestModel(
    val id: String?,
    val employeeId: String?,
    val requestOffTime: LocalDate,
    val approved: Boolean?,
    val reviewedDate: LocalDate?,
    val requestSubmittedDateTime: LocalDateTime
) {
    fun toTimeOffRequestDto(): TimeOffRequestDto {
        return TimeOffRequestDto(
            employeeId = employeeId,
            requestOffTime = requestOffTime,
            approved = approved,
            reviewedDate = reviewedDate,
            requestSubmittedDateTime = requestSubmittedDateTime
        )
    }
}